module.exports = __webpack_public_path__ + "static/img/acil.7016a859.svg";